import React from "react";
import styled from 'styled-components';
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import ClaroImage from '../../molecules/ClaroImage'

const Container = styled.div`
  width: 100%;
  background: #f4f4f4;
  border-radius: 0em 0em 1.5em 1.5em;
  padding-top: 1em;
  padding-bottom: 1em;
`;

const TitleMonto = styled.div`
  color: #5f5f5f;
  font-size: .8em;
  font-family: 'RobotoRegular', sans-serif;
  text-align: center;
`;

const HeaderPaymentFormClaroSocio = ({dataConfigLogo, serviceSubtitleLabel, serviceTitle}) => {
    let stylesDescription = {color: "#ff6028", position:"absolute", paddingTop:"5em", fontSize:".6em"};
    let subtitle =  (serviceSubtitleLabel)?serviceSubtitleLabel: "Monto a pagar por el servicio"
    return(
        <Container>
            <ProgressBar percent={50} height=".13em" filledBackground={"#ff6028"}>
                <Step>
                    {({ accomplished, index }) => (
                        <>
                            <div className={`indexedStep ${accomplished ? "accomplished" : null}`} >
                                <i className="fas fa-check" ></i> 
                            </div>
                            <div style={stylesDescription}>
                                Elige
                            </div>
                        </>
                    )}
                </Step>
                <Step>
                    {({ accomplished, index }) => (
                        <>
                            <div
                                className={`indexedStep ${accomplished ? "accomplished" : null}`}
                            >
                            </div>
                            <div style={stylesDescription}>
                                Monto
                            </div>
                        </>
                    )}
                </Step>
                <Step style={{color:"#444"}}>
                    {({ accomplished, index }) => (
                        <>
                            <div
                                className={`indexedStep ${accomplished ? "accomplished" : null}`}
                            >
                            </div>
                            <div style={{color: "#ccc", position:"absolute", paddingTop:"5em", fontSize:".6em"}}>
                                Paga
                            </div>
                        </>
                    )}
                </Step>
            </ProgressBar>
            <ClaroImage {...dataConfigLogo}  isClaroPartner = {true} isLogoHeaderClaroSocio={true} title={serviceTitle} />
                    <TitleMonto>{subtitle}</TitleMonto>
        </Container>
    )
}


export default HeaderPaymentFormClaroSocio;